import { Path, Transforms } from 'slate'

import {
  CustomEditor,
  TTableCellElement,
} from 'core-components/library/richTextEditor/interface/custom-types'

import {
  createRow,
  getCol,
  getGridTable,
  getStartCell,
  isTable,
  TableCol,
} from './commonTableHelper'
import { getInsertPositionCol } from './getInsertPositionHelper'

export const checkInsertAbowe = (gridTable: TableCol[][], y: number, yIndex: number) => {
  const insertCols = new Map<string, TableCol>()
  let canInsertableAbowe = true
  gridTable[y].forEach((col: TableCol) => {
    if (!col.isReal) {
      const [originCol] = getCol(
        gridTable,
        (c: TableCol) => c.isReal && c.cell.key === col.cell.key
      )
      if (originCol.path[yIndex] === y) {
        insertCols.set(originCol.cell.key, originCol)
      } else {
        canInsertableAbowe = false
        return
      }
    } else {
      insertCols.set(col.cell.key, col)
    }
  })

  return { insertCols, canInsertableAbowe }
}

export const checkInsertBelow = (gridTable: TableCol[][], y: number, yIndex: number) => {
  const insertCols = new Map<string, TableCol>()
  let canInsertableBelow = true
  gridTable[y].forEach((col: TableCol) => {
    const [originCol] = getCol(gridTable, (n: any) => n.isReal && n.cell.key === col.cell.key)
    const { cell, path } = originCol
    if (!gridTable[y + 1]) {
      insertCols.set(cell.key, originCol)
    } else if (path[yIndex] + (cell.rowspan || 1) - 1 === y) {
      insertCols.set(cell.key, originCol)
    } else {
      canInsertableBelow = false
      return
    }
  })

  return { insertCols, canInsertableBelow }
}

export const canInsertRowAbowe = (editor: CustomEditor) => {
  const result = { insertCols: new Map<string, TableCol>(), canInsertableAbowe: true }
  if (!editor.selection || !isTable(editor)) {
    return result
  }
  const { gridTable, yIndex } = getGridTable(editor)
  const insertPositionCol = getInsertPositionCol(editor)
  if (!insertPositionCol) {
    return result
  }
  const insertYIndex = insertPositionCol.path[yIndex]

  const { canInsertableAbowe, insertCols } = checkInsertAbowe(gridTable, insertYIndex, yIndex)
  result.canInsertableAbowe = canInsertableAbowe
  result.insertCols = insertCols

  return result
}

export const canInsertRowBelow = (editor: CustomEditor) => {
  const result = { insertCols: new Map<string, TableCol>(), canInsertableBelow: true }
  if (!editor.selection || !isTable(editor)) {
    return result
  }
  const { gridTable, yIndex } = getGridTable(editor)
  const insertPositionCol = getInsertPositionCol(editor)
  if (!insertPositionCol) {
    return result
  }
  const y = insertPositionCol.path[yIndex] + (insertPositionCol.cell.rowspan || 1) - 1
  const { canInsertableBelow, insertCols } = checkInsertBelow(gridTable, y, yIndex)
  result.canInsertableBelow = canInsertableBelow
  result.insertCols = insertCols

  return result
}

export const insertRowAbowe = (editor: CustomEditor) => {
  const { insertCols, canInsertableAbowe } = canInsertRowAbowe(editor)

  if (canInsertableAbowe && insertCols) {
    const newRow = createRow({ columns: insertCols.size })
    const [, path] = getStartCell(editor)
    Transforms.insertNodes(editor, newRow, {
      at: Path.parent(path),
    })
  }
}

export const insertRowBelow = (editor: CustomEditor) => {
  const { insertCols, canInsertableBelow } = canInsertRowBelow(editor)

  if (canInsertableBelow && insertCols) {
    const { yIndex } = getGridTable(editor)
    const startCell = getStartCell(editor)
    const startCellElement = startCell[0] as TTableCellElement
    const newRow = createRow({ columns: insertCols.size })
    const [, path] = getStartCell(editor)
    for (let i = 1; i < startCellElement.rowspan; i++) {
      path[yIndex] += 1
    }
    Transforms.insertNodes(editor, newRow, {
      at: Path.next(Path.parent(path)),
    })
  }
}
